import * as z from "zod";

export const setUsingDiscountRules = {
  name: "setUsingDiscountRules" as const,
  input: z.object({ enabled: z.boolean() }),
  output: z.null(),
};
